var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 82,
    viewBox: "0 0 163 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.737 81.4213C161.737 60.1202 153.275 39.6916 138.213 24.6294C123.151 9.56729 102.722 1.10547 81.4213 1.10547C60.1202 1.10547 39.6916 9.56728 24.6294 24.6294C9.56729 39.6915 1.10547 60.1202 1.10547 81.4213",
    stroke: "black",
    strokeWidth: 0.736842,
    strokeLinecap: "round",
    strokeDasharray: "0 0.74 7.37 0 0.74 7.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.b55d1f750dd0410dec8b092467e398f1.svg";
export { ForwardRef as ReactComponent };